import styled, { css } from 'styled-components';
import { PlayBadge } from '../../../PlayBadge/PlayBadge';
import { device } from '../../../breakpoints';

export const StyledBadge = styled(PlayBadge)`
    position: absolute;
    display: block;
    top: 10px;
    left: 10px;

    @media ${device.GteSmall} {
        top: 15px;
        left: 15px;
    }

    @media ${device.GteLarge} {
        top: 15px;
    }
    ${(props) =>
        props.hidden &&
        css`
            display: none;
        `}
`;
